import { Grid } from '@mui/material';
import { CerebroComplexListItem, CerebroLabel, CerebroText } from '../../shared/components';
import { TermSheet } from '../../shared/models';
import { DateUtils, NumberUtils } from '../../shared/utils';

interface ExistingDebtTermListItemProps {
	debtTerm: TermSheet;
	onEdit: (term: TermSheet) => void;
	onDelete: (term: TermSheet) => void;
}

export const ExistingDebtTermListItem: React.FC<ExistingDebtTermListItemProps> = ({ debtTerm, onEdit, onDelete }) => {
	const revisions = debtTerm.revisions.map(revision => revision.facilities).flat();
	const showDelete = revisions.filter(facility => facility.painPoint != null).length > 0;

	return (
		<CerebroComplexListItem
			tags={['Debt Term']}
			sx={{ marginY: 2 }}
			onEdit={() => onEdit(debtTerm)}
			onDelete={() => onDelete(debtTerm)}
			onDeleteTitle={`Delete the existing debt term for ${debtTerm.bankName}`}
			showDelete={showDelete}
		>
			<Grid container spacing={3} alignItems="flex-end">
				<Grid item xs={6} md={4}>
					<CerebroLabel>Bank</CerebroLabel>
					<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
						{debtTerm.bankName}
					</CerebroText>
				</Grid>
				<Grid item xs={6} md={4}>
					<CerebroLabel>Amount</CerebroLabel>
					<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
						{NumberUtils.FormatCurrency(debtTerm.totalAmount, '--')}
					</CerebroText>
				</Grid>
				<Grid item xs={6} md={4}>
					<CerebroLabel>Received On</CerebroLabel>
					<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
						{DateUtils.FormatStringAsShortDate(debtTerm.dateReceived.toString()) ?? '--'}
					</CerebroText>
				</Grid>
				<Grid item xs={6} md={4}>
					<CerebroLabel>Terms Effective On</CerebroLabel>
					<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
						{DateUtils.FormatStringAsShortDate(debtTerm.termsEffectiveDate?.toString()) ?? '--'}
					</CerebroText>
				</Grid>
			</Grid>
		</CerebroComplexListItem>
	);
};
